module.exports = __webpack_public_path__ + "static/media/u110_normal.b28a81c8.gif";